import { Tabs } from '@/components/layout/Tabs';
import { StyledTab } from '@/pages/ManageDelivery/PageManageDeliveryTabs/style';
import PageManageDelivery from '@/pages/ManageDelivery/PageManageDelivery';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

const PageManageDeliveryTabs = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const [selectedTab, setSelectedTab] = useState<number>(
    location.state?.tab ?? 0
  );
  const FLOW_TABS_CONFIG = [
    {
      label: t('deliveryManagement.tab.mndl'),
      flowType: 'MNDL',
    },
    {
      label: t('deliveryManagement.tab.pdm'),
      flowType: 'PDM',
    },
  ] as const;
  const FLOW_TABS = FLOW_TABS_CONFIG.map(({ label }) => label);
  const selectedFlowType = FLOW_TABS_CONFIG[selectedTab].flowType;

  return (
    <>
      <Tabs
        values={FLOW_TABS}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <StyledTab>
        <PageManageDelivery key={selectedFlowType} flowType={selectedFlowType} />
      </StyledTab>
    </>
  );
};

export default PageManageDeliveryTabs
